/** Agent-spine (ADR-003): a concrete output of an activity (file, doc, artifact ref). */
export const deliverableDescriptor = {
    slug: 'deliverable',
    kind: 'document',
    label: { singular: 'Consegna', plural: 'Consegne' },
    table: 'ai_portal_deliverable',
    idStrategy: 'sha256',
    fields: [
        { name: 'type', type: 'text', label: 'Tipo', required: true },
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'ref', type: 'text', label: 'Riferimento' },
        { name: 'activity_id', type: 'text', label: 'ID attività' },
        { name: 'producer_ref', type: 'text', label: 'Produttore' },
        { name: 'target_ref', type: 'text', label: 'Destinatario' },
        { name: 'metadata', type: 'json', label: 'Metadati' },
    ],
    behaviors: {
        audit: true,
        tenantScoped: true,
    },
    emits: ['deliverable.pushed'],
    ui: { mode: 'generated', icon: 'FileDoneOutlined', navGroup: 'Agenti', navOrder: 43 },
};
